import dotenv from 'dotenv';

dotenv.config();

const strapiBaseUrl = process.env.REACT_APP_STRAPI_API_URL;
const accessToken = process.env.REACT_APP_ACCESS_TOKEN;

const projectsEndpoint = `${strapiBaseUrl}/projects`;

const fetchConfig = {
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
};

export async function fetchProjects() {
    try {
        const response = await fetch(`${projectsEndpoint}?populate=*&sort[1]=publishedAt:desc`, fetchConfig);
        if (!response.ok) {
            throw new Error('Failed to fetch data from Strapi backend.');
        }
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}

export async function fetchLandingProjects() {
    try {
        const response = await fetch(`${projectsEndpoint}?populate=*&sort[1]=publishedAt:desc&pagination[page]=1&pagination[pageSize]=3`, fetchConfig);
        if (!response.ok) {
            throw new Error('Failed to fetch data from Strapi backend.');
        }
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}

export async function fetchSingleProject(slug: string) {
    try {
        const endpointUrl = `${projectsEndpoint}?filters[slug][$eq]=${slug}&populate=*`;

        const response = await fetch(endpointUrl, fetchConfig);
        if (!response.ok) {
            throw new Error('Failed to fetch data from Strapi backend.');
        }
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}